import React, { useEffect, useRef } from 'react';
import kayraImg from '../img/kayra-dj.jpg';

const TYPEFORM_URL = 'https://karmanbeyond.typeform.com/to/PSPTxktj';

const STRING_LEN = 92;
const BALL_R = 64;
const BASE_SPEED = 0.4; // rad/s, boşta dönüş hızı

const buildFacets = () => {
  const facets = [];
  const bands = 13;
  const latSpan = 2.7; // ±77°
  for (let i = 0; i < bands; i++) {
    const lat0 = -latSpan / 2 + (i / bands) * latSpan;
    const lat1 = lat0 + latSpan / bands;
    const latC = (lat0 + lat1) / 2;
    const count = Math.max(4, Math.round(30 * Math.cos(latC)));
    for (let j = 0; j < count; j++) {
      const lon0 = (j / count) * Math.PI * 2;
      const lon1 = lon0 + (Math.PI * 2) / count;
      facets.push({
        lat0,
        lat1,
        lon0,
        lon1,
        tint: (Math.random() - 0.5) * 34,
        seed: Math.random(),
      });
    }
  }
  return facets;
};

// Davetiyenin alt bölümüne serpiştirilen parti çizimleri. Her ikon kendi
// içeriğine göre kırpılmış bir viewBox taşır; çizgi kalınlığı non-scaling-stroke
// ile sabit tutulduğu için her boyutta aynı incelikte görünürler.
const ICONS = {
  dancerMan: {
    vb: '2 1 26 56',
    d: (
      <>
        <circle cx="17" cy="8" r="4.4" />
        <path d="M17 12.4 C16.4 20, 15 27, 16.6 34" />
        <path d="M16.7 18 C20 13, 23 8, 24 3" />
        <path d="M16.7 18 C13 21, 9 23, 5 22" />
        <path d="M16.6 34 C19 41, 22 47, 24.5 54" />
        <path d="M16.6 34 C13 40, 10 45, 7 51" />
      </>
    ),
  },
  dancerManB: {
    vb: '2 1 28 56',
    d: (
      <>
        <circle cx="14" cy="9" r="4.4" />
        <path d="M14 13.4 C15 21, 16 28, 15.4 35" />
        <path d="M14.8 19 C18 15, 22 12, 26 11" />
        <path d="M14.8 19 C11 23, 8 27, 6 31" />
        <path d="M15.4 35 C13 42, 11 48, 9 54" />
        <path d="M15.4 35 C18 41, 21 46, 24 51" />
      </>
    ),
  },
  dancerWoman: {
    vb: '3 1 25 59',
    d: (
      <>
        <circle cx="18" cy="8" r="4.2" />
        <path d="M18 12.2 C17.6 17, 17 21, 17.4 25" />
        <path d="M17.8 16 C21 11, 24 7, 25 2" />
        <path d="M17.8 16 C14 18, 10 19, 6 18" />
        <path d="M17.4 25 L10 42" />
        <path d="M17.4 25 L25 42" />
        <path d="M10 42 C13.5 45, 21.5 45, 25 42" />
        <path d="M14.5 43.5 C13.8 49, 13 53, 12.4 57" />
        <path d="M20.5 43.5 C21.2 49, 22 53, 22.6 57" />
      </>
    ),
  },
  dancerWomanB: {
    vb: '3 1 27 59',
    d: (
      <>
        <circle cx="15" cy="9" r="4.2" />
        <path d="M15 13.2 C15.6 18, 16 22, 15.6 26" />
        <path d="M15.4 17 C12 13, 8 10, 5 8" />
        <path d="M15.4 17 C19 19, 23 21, 27 20" />
        <path d="M15.6 26 L8 43" />
        <path d="M15.6 26 L23 43" />
        <path d="M8 43 C11.5 46, 19.5 46, 23 43" />
        <path d="M12.5 44.5 C11.8 50, 11 54, 10.4 58" />
        <path d="M18.5 44.5 C19.2 50, 20 54, 20.6 58" />
      </>
    ),
  },
  cake: {
    vb: '5 1 80 60',
    d: (
      <>
        <path d="M31 15 C27.5 12, 29 7.5, 31 5 C33 7.5, 34.5 12, 31 15 Z" />
        <path d="M45 15 C41.5 12, 43 7.5, 45 5 C47 7.5, 48.5 12, 45 15 Z" />
        <path d="M59 15 C55.5 12, 57 7.5, 59 5 C61 7.5, 62.5 12, 59 15 Z" />
        <path d="M31 15 L31 26 M45 15 L45 26 M59 15 L59 26" />
        <path d="M16 26 L74 26" />
        <path d="M16 26 C16 32, 20.5 33, 23 29.5 C25.5 33, 30 33, 32.5 29.5 C35 33, 39.5 33, 42 29.5 C44.5 33, 49 33, 51.5 29.5 C54 33, 58.5 33, 61 29.5 C63.5 33, 68 33, 70.5 29.5 C72 32, 73.5 32, 74 26" />
        <path d="M16 26 L16 49 M74 26 L74 49" />
        <path d="M16 49 L74 49" />
        <path d="M9 52 C22 58, 68 58, 81 52" />
      </>
    ),
  },
  cupcake: {
    vb: '2 1 36 44',
    d: (
      <>
        <path d="M20 12 C17 9.5, 18.4 5.5, 20 3 C21.6 5.5, 23 9.5, 20 12 Z" />
        <path d="M20 12 L20 17" />
        <path d="M6 20 C10 14, 30 14, 34 20" />
        <path d="M6 20 L9 40 C9 42, 31 42, 31 40 L34 20 Z" />
        <path d="M13 20 L12 41 M20 20 L20 42 M27 20 L28 41" />
      </>
    ),
  },
  gift: {
    vb: '2 2 40 38',
    d: (
      <>
        <path d="M6 16 L38 16 L38 38 L6 38 Z" />
        <path d="M4 10 L40 10 L40 16 L4 16 Z" />
        <path d="M22 10 L22 38" />
        <path d="M22 10 C18 4, 12 3.5, 13 7.5 C13.6 9.6, 18 10, 22 10 Z" />
        <path d="M22 10 C26 4, 32 3.5, 31 7.5 C30.4 9.6, 26 10, 22 10 Z" />
      </>
    ),
  },
  balloon: {
    vb: '2 1 20 38',
    d: (
      <>
        <ellipse cx="12" cy="12" rx="8" ry="10" />
        <path d="M10.6 22 L12 25 L13.4 22" />
        <path d="M12 25 C14.5 29, 9.5 32, 12 38" />
      </>
    ),
  },
  coupe: {
    vb: '1 4 28 34',
    d: (
      <>
        <path d="M3 8 L27 8 C27 19, 21 25, 15 25 C9 25, 3 19, 3 8 Z" />
        <path d="M15 25 L15 34" />
        <path d="M8 36 L22 36" />
      </>
    ),
  },
  martini: {
    vb: '1 4 28 34',
    d: (
      <>
        <path d="M3 8 L27 8 L15 24 Z" />
        <path d="M15 24 L15 34" />
        <path d="M8 36 L22 36" />
        <circle cx="15" cy="13.5" r="2" />
      </>
    ),
  },
  partyHat: {
    vb: '1 0 28 42',
    d: (
      <>
        <path d="M15 7.5 L4 40 L26 40 Z" />
        <circle cx="15" cy="4" r="3.2" />
        <path d="M8.5 27 C12 25, 18 25, 21.5 27" />
        <path d="M11 17.5 C13 16.5, 17 16.5, 19 17.5" />
      </>
    ),
  },
  musicNote: {
    vb: '2 2 26 36',
    d: (
      <>
        <ellipse cx="9.5" cy="30" rx="6" ry="4.6" transform="rotate(-20 9.5 30)" />
        <path d="M15 29 L15 5" />
        <path d="M15 5 C20 7, 24 11, 22 18" />
      </>
    ),
  },
};

const Decor = ({ n, w, rot = 0, op = 0.38, ...pos }) => (
  <svg
    className="bday-sketch absolute h-auto"
    viewBox={ICONS[n].vb}
    style={{ ...pos, width: `${w}px`, transform: `rotate(${rot}deg)`, opacity: op }}
    aria-hidden="true"
  >
    {ICONS[n].d}
  </svg>
);

// Geniş ekranda (lg+) metin sütununun iki yanına serpiştirilenler. Her ikonun
// yüksekliği eninin katı olduğundan (ör. kadın figürü ~2,4 kat) dikey aralıklar
// bu yüksekliklere göre verildi; iki dış/iç sütun halinde dağıtılıyorlar.
const DECOR_WIDE = [
  { n: 'dancerWoman', left: '-26%', top: '0%', w: 44, rot: -7 },
  { n: 'cake', left: '-11%', top: '8%', w: 56, rot: 3 },
  { n: 'dancerManB', left: '-15%', top: '23%', w: 40, rot: 6 },
  { n: 'balloon', left: '-29%', top: '28%', w: 26, rot: -10 },
  { n: 'cupcake', left: '-24%', top: '45%', w: 30, rot: 4 },
  { n: 'gift', left: '-9%', top: '45%', w: 38, rot: -4 },
  { n: 'dancerWomanB', left: '-17%', top: '60%', w: 40, rot: 4 },
  { n: 'partyHat', left: '-30%', top: '62%', w: 26, rot: -6 },
  { n: 'musicNote', left: '-8%', top: '68%', w: 22, rot: -8 },
  { n: 'coupe', left: '-28%', top: '84%', w: 26 },
  { n: 'martini', left: '-12%', top: '88%', w: 26, rot: 3 },
  { n: 'dancerMan', right: '-24%', top: '3%', w: 44, rot: 7 },
  { n: 'martini', right: '-9%', top: '9%', w: 28 },
  { n: 'cake', right: '-30%', top: '32%', w: 50, rot: -3 },
  { n: 'dancerWoman', right: '-14%', top: '23%', w: 42, rot: -5 },
  { n: 'gift', right: '-25%', top: '45%', w: 34, rot: 5 },
  { n: 'balloon', right: '-7%', top: '50%', w: 24, rot: 8 },
  { n: 'cupcake', right: '-19%', top: '60%', w: 30, rot: -4 },
  { n: 'dancerWomanB', right: '-10%', top: '68%', w: 40, rot: 4 },
  { n: 'partyHat', right: '-29%', top: '76%', w: 24, rot: 7 },
  { n: 'musicNote', right: '-21%', top: '90%', w: 20, rot: 6 },
  { n: 'coupe', right: '-6%', top: '95%', w: 24 },
];

// Dar ekranda yalnızca butonun iki yanına ve altına sığanlar. Konumlar piksel
// cinsinden: yüzde kullanılırsa 1023px'e kadar olan aralıkta kenardan taşıyorlar.
// Metin sütunu bu ölçülerde neredeyse tam genişlikte olduğu için not satırının
// hizasına çizim konmuyor.
const DECOR_NARROW = [
  { n: 'dancerWoman', left: '-18px', top: '63%', w: 24, rot: -4 },
  { n: 'coupe', right: '-16px', top: '66%', w: 19 },
  { n: 'dancerMan', left: '2px', top: '85%', w: 20, rot: 4 },
  { n: 'gift', left: '48px', top: '90%', w: 24, rot: -4 },
  { n: 'cupcake', left: '96px', top: '91%', w: 20, rot: 3 },
  { n: 'partyHat', right: '96px', top: '89%', w: 19, rot: 4 },
  { n: 'martini', right: '56px', top: '91%', w: 16 },
  { n: 'balloon', right: '14px', top: '86%', w: 20 },
];

const BirthdayInvite = () => {
  const canvasRef = useRef(null);
  const anchorRef = useRef(null);

  useEffect(() => {
    const prevTitle = document.title;
    document.title = 'You Are Invited To My Birthday Party';

    const discoFavicon =
      'data:image/svg+xml,' +
      encodeURIComponent(
        "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><text y='.9em' font-size='90'>🪩</text></svg>"
      );
    let link = document.querySelector("link[rel~='icon']");
    const prevHref = link ? link.href : null;
    let createdLink = null;
    if (link) {
      link.href = discoFavicon;
    } else {
      createdLink = document.createElement('link');
      createdLink.rel = 'icon';
      createdLink.href = discoFavicon;
      document.head.appendChild(createdLink);
    }

    return () => {
      document.title = prevTitle;
      if (link && prevHref) link.href = prevHref;
      if (createdLink) createdLink.remove();
    };
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    const anchor = anchorRef.current;
    if (!canvas || !anchor) return undefined;
    const ctx = canvas.getContext('2d');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const facets = buildFacets();

    // ışık yönü (izleyicinin sol üstünden)
    const L = { x: -0.5, y: 0.6, z: 0.65 };
    const lLen = Math.hypot(L.x, L.y, L.z);
    L.x /= lLen; L.y /= lLen; L.z /= lLen;
    // yarı vektör (specular için, bakış = +z)
    const H = { x: L.x, y: L.y, z: L.z + 1 };
    const hLen = Math.hypot(H.x, H.y, H.z);
    H.x /= hLen; H.y /= hLen; H.z /= hLen;

    let width = 0;
    let height = 0;
    let raf = 0;
    let theta = 0.6;
    let extraSpeed = 0;
    let lastScrollY = window.scrollY;
    let lastT = 0;

    const resize = () => {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = Math.round(width * dpr);
      canvas.height = Math.round(height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };

    const onScroll = () => {
      const y = window.scrollY;
      const dy = y - lastScrollY;
      lastScrollY = y;
      // scroll hızı topa ivme verir
      extraSpeed = Math.max(-2.6, Math.min(2.6, extraSpeed + dy * 0.0045));
      if (reduced) draw(0.001);
    };

    const drawBall = (time) => {
      const rect = anchor.getBoundingClientRect();
      const cx0 = rect.left + rect.width / 2;
      const pivotY = rect.top;
      if (pivotY + STRING_LEN + BALL_R * 2 + 80 < 0) return; // ekranın üstünde kaldıysa çizme

      const sway = reduced ? 0.02 : 0.045 * Math.sin(time * 0.45);
      const dx = Math.sin(sway);
      const dy = Math.cos(sway);
      const topX = cx0 + dx * STRING_LEN;
      const topY = pivotY + dy * STRING_LEN;
      const cx = cx0 + dx * (STRING_LEN + BALL_R);
      const cy = pivotY + dy * (STRING_LEN + BALL_R);

      // ip
      const strGrad = ctx.createLinearGradient(cx0, pivotY, topX, topY);
      strGrad.addColorStop(0, 'rgba(255,255,255,0.04)');
      strGrad.addColorStop(1, 'rgba(255,255,255,0.45)');
      ctx.strokeStyle = strGrad;
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(cx0, pivotY);
      ctx.lineTo(topX, topY);
      ctx.stroke();

      // topun arkasındaki hale
      const halo = ctx.createRadialGradient(cx, cy, BALL_R * 0.4, cx, cy, BALL_R * 2.5);
      halo.addColorStop(0, 'rgba(255,255,255,0.11)');
      halo.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = halo;
      ctx.beginPath();
      ctx.arc(cx, cy, BALL_R * 2.5, 0, Math.PI * 2);
      ctx.fill();

      // küre tabanı (fayans aralarında görünen koyu zemin)
      ctx.fillStyle = '#0e0e0e';
      ctx.beginPath();
      ctx.arc(cx, cy, BALL_R, 0, Math.PI * 2);
      ctx.fill();

      // aynacıklar
      const sparkles = [];
      const project = (lat, lon) => ({
        x: cx + BALL_R * 0.985 * Math.cos(lat) * Math.sin(lon),
        y: cy - BALL_R * 0.985 * Math.sin(lat),
      });
      for (let i = 0; i < facets.length; i++) {
        const f = facets[i];
        const latC = (f.lat0 + f.lat1) / 2;
        const lonC = (f.lon0 + f.lon1) / 2 + theta;
        const cosLat = Math.cos(latC);
        const nz = cosLat * Math.cos(lonC);
        if (nz <= 0.04) continue;
        const nx = cosLat * Math.sin(lonC);
        const ny = Math.sin(latC);

        const diff = Math.max(0, nx * L.x + ny * L.y + nz * L.z);
        const spec = Math.pow(Math.max(0, nx * H.x + ny * H.y + nz * H.z), 42);
        let v = 24 + Math.pow(diff, 1.5) * 132 + f.tint;
        v = Math.min(252, Math.max(8, v + spec * 215));

        // fayansı merkeze doğru büzerek derz araligi bırak
        const s = 0.78;
        const la0 = latC + (f.lat0 - latC) * s;
        const la1 = latC + (f.lat1 - latC) * s;
        const lo0 = lonC + (f.lon0 + theta - lonC) * s;
        const lo1 = lonC + (f.lon1 + theta - lonC) * s;
        const p1 = project(la0, lo0);
        const p2 = project(la0, lo1);
        const p3 = project(la1, lo1);
        const p4 = project(la1, lo0);

        ctx.fillStyle = `rgb(${v | 0},${v | 0},${v | 0})`;
        ctx.beginPath();
        ctx.moveTo(p1.x, p1.y);
        ctx.lineTo(p2.x, p2.y);
        ctx.lineTo(p3.x, p3.y);
        ctx.lineTo(p4.x, p4.y);
        ctx.closePath();
        ctx.fill();

        // ara sıra göz kırpan yıldız parlamaları
        if (!reduced && spec > 0.18) {
          const tw = (f.seed * 13.7 + time * 0.09) % 1;
          if (tw < 0.02) {
            sparkles.push({ x: (p1.x + p3.x) / 2, y: (p1.y + p3.y) / 2, r: 5 + f.seed * 5 });
          }
        }
      }

      // kenar gölgesi — küresel derinlik
      const rim = ctx.createRadialGradient(cx, cy, BALL_R * 0.5, cx, cy, BALL_R);
      rim.addColorStop(0, 'rgba(0,0,0,0)');
      rim.addColorStop(0.72, 'rgba(0,0,0,0.06)');
      rim.addColorStop(1, 'rgba(0,0,0,0.55)');
      ctx.fillStyle = rim;
      ctx.beginPath();
      ctx.arc(cx, cy, BALL_R, 0, Math.PI * 2);
      ctx.fill();

      // sol üst cila
      const sheen = ctx.createRadialGradient(
        cx - BALL_R * 0.38, cy - BALL_R * 0.42, 0,
        cx - BALL_R * 0.38, cy - BALL_R * 0.42, BALL_R * 0.9
      );
      sheen.addColorStop(0, 'rgba(255,255,255,0.20)');
      sheen.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = sheen;
      ctx.beginPath();
      ctx.arc(cx, cy, BALL_R, 0, Math.PI * 2);
      ctx.fill();

      // askı başlığı
      ctx.fillStyle = '#333';
      ctx.beginPath();
      ctx.ellipse(topX, topY + 1, 6, 3, sway, 0, Math.PI * 2);
      ctx.fill();

      // yıldız parlamaları en üste
      for (const sp of sparkles) {
        const g = ctx.createRadialGradient(sp.x, sp.y, 0, sp.x, sp.y, sp.r * 2);
        g.addColorStop(0, 'rgba(255,255,255,0.9)');
        g.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(sp.x, sp.y, sp.r * 2, 0, Math.PI * 2);
        ctx.fill();
        ctx.strokeStyle = 'rgba(255,255,255,0.85)';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(sp.x - sp.r, sp.y);
        ctx.lineTo(sp.x + sp.r, sp.y);
        ctx.moveTo(sp.x, sp.y - sp.r);
        ctx.lineTo(sp.x, sp.y + sp.r);
        ctx.stroke();
      }
    };

    const draw = (time) => {
      ctx.clearRect(0, 0, width, height);
      drawBall(time);
    };

    const frame = (now) => {
      const time = now / 1000;
      const dt = Math.min(0.05, lastT ? time - lastT : 0.016);
      lastT = time;
      extraSpeed *= Math.exp(-dt * 1.7); // scroll ivmesi yavaşça söner
      theta += (BASE_SPEED + extraSpeed) * dt;
      draw(time);
      raf = requestAnimationFrame(frame);
    };

    const onResize = () => {
      resize();
      if (reduced) draw(0.001);
    };

    resize();
    window.addEventListener('resize', onResize);
    window.addEventListener('scroll', onScroll, { passive: true });
    if (reduced) {
      draw(0.001);
    } else {
      raf = requestAnimationFrame(frame);
    }

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <div className="bday-page relative w-full overflow-hidden">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&family=Great+Vibes&family=Jost:ital,wght@0,200;0,300;0,400;0,500;1,300;1,400&family=Caveat:wght@500;600;700&display=swap');

        .bday-page {
          background: #070707;
          min-height: 100vh;
          color: #F1EAD9;
        }
        .bday-jost { font-family: 'Jost', sans-serif; }
        .bday-serif { font-family: 'Cormorant Garamond', serif; }
        .bday-script { font-family: 'Great Vibes', cursive; }
        .bday-hand { font-family: 'Caveat', cursive; }

        .bday-canvas {
          position: fixed;
          inset: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          z-index: 1;
        }

        /* --- ışık --- */
        .bday-ambient {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 80vh;
          background: radial-gradient(ellipse 85% 50% at 50% 0%, rgba(255,255,255,0.09), rgba(255,255,255,0.025) 45%, transparent 70%);
          pointer-events: none;
        }

        /* --- görsel --- */
        .bday-kayra {
          -webkit-mask-image: radial-gradient(ellipse 68% 58% at 50% 47%, #000 50%, transparent 82%);
          mask-image: radial-gradient(ellipse 68% 58% at 50% 47%, #000 50%, transparent 82%);
          filter: grayscale(1) contrast(1.04);
        }

        /* --- parti çizimleri --- */
        .bday-sketch {
          fill: none;
          stroke: #C9AF87;
          stroke-width: 1.4;
          stroke-linecap: round;
          stroke-linejoin: round;
        }
        .bday-sketch * { vector-effect: non-scaling-stroke; }
        .bday-sketch .bday-sketch-fill { fill: #C9AF87; stroke: none; }

        /* --- buton --- */
        .bday-btn {
          font-family: 'Jost', sans-serif;
          font-weight: 500;
          letter-spacing: 0.32em;
          text-transform: uppercase;
          font-size: 0.85rem;
          color: #0a0a0a;
          background: #ffffff;
          border: none;
          border-radius: 14px;
          padding: 1.15rem 2.9rem 1.15rem 3.2rem;
          transition: all 0.45s ease;
        }
        .bday-btn:hover {
          background: #F1EAD9;
          box-shadow: 0 0 45px rgba(255, 255, 255, 0.25);
        }
        /* dar ekranda butonun yanında dekorlara yer kalsın */
        @media (max-width: 639px) {
          .bday-btn { padding: 1.05rem 2.1rem 1.05rem 2.3rem; }
        }

        @media (prefers-reduced-motion: reduce) {
          .bday-page *, .bday-page { animation: none !important; }
        }
      `}</style>

      {/* ortam ışığı */}
      <div className="bday-ambient" />

      {/* disko topu */}
      <canvas ref={canvasRef} className="bday-canvas" aria-hidden="true" />

      <main className="relative z-10 max-w-2xl mx-auto px-6 flex flex-col items-center text-center pb-24">
        {/* disko topunun sayfadaki yeri (canvas buraya çizer) */}
        <div ref={anchorRef} className="w-full h-[220px]" aria-hidden="true" />

        {/* başlık */}
        {/* Satırların ortalaması: harf aralığı son harften sonra da uygulandığı için
            metin sola kayar, negatif sağ boşluk bunu geri alır. Caveat sağa yatık
            olduğundan mürekkebi kutusunun sağında kalır, translate ile ortalanır. */}
        <p className="bday-jost mt-14 text-[14px] sm:text-[16px] font-light uppercase tracking-[0.22em] sm:tracking-[0.5em] leading-loose text-[#F1EAD9]/70 whitespace-nowrap">
          <span className="block -mr-[0.22em] sm:-mr-[0.5em]">Wear your best party outfit</span>
          <span className="block -mr-[0.22em] sm:-mr-[0.5em]">and get ready to</span>
          <span className="bday-hand block mt-6 -translate-x-[0.1em] -rotate-6 text-[42px] sm:text-[52px] font-bold leading-[1.05] tracking-normal text-white">
            Celebrate
          </span>
        </p>

        {/* kayra — yazı ve ok görsele göre yüzdeyle konumlanır ki ok ucu her ekran
            genişliğinde kafanın aynı noktasına insin */}
        <div className="mt-8 w-full max-w-xl pt-[19%]">
          <div className="relative">
            <img
              src={kayraImg}
              alt="Kayra"
              className="bday-kayra w-full select-none"
              draggable="false"
            />
            <div
              className="absolute w-[19%] pointer-events-none"
              style={{ left: '53.56%', top: '-15.65%' }}
            >
              <svg className="w-full h-auto" viewBox="0 0 140 130" fill="none" aria-hidden="true">
                <path
                  d="M118 8 C 90 0, 72 18, 83 32 C 92 44, 112 38, 105 23 C 99 11, 77 15, 67 34 C 55 56, 50 80, 46 104"
                  stroke="#C9AF87"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  opacity="0.9"
                />
                <path
                  d="M46 104 L52 87 M46 104 L33 93"
                  stroke="#C9AF87"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  opacity="0.9"
                />
              </svg>
              <span
                className="bday-hand absolute bottom-full text-3xl sm:text-4xl text-[#C9AF87] -rotate-3 whitespace-nowrap"
                style={{ right: '-92%' }}
              >
                Kayra will make you move
              </span>
            </div>
          </div>
        </div>

        <div className="relative w-full mt-12 flex flex-col items-center">
        {/* parti çizimleri: metin sütununun çevresine serpiştirilir */}
        {/* katman metin bloğunun biraz altına taşar ki çizimler daha geniş bir
            alana yayılabilsin */}
        <div
          className="hidden lg:block absolute left-0 right-0 top-0 pointer-events-none"
          style={{ bottom: '-80px' }}
          aria-hidden="true"
        >
          {DECOR_WIDE.map((d, i) => (
            <Decor key={i} {...d} />
          ))}
        </div>
        <div
          className="lg:hidden absolute left-0 right-0 top-0 pointer-events-none"
          style={{ bottom: '-70px' }}
          aria-hidden="true"
        >
          {DECOR_NARROW.map((d, i) => (
            <Decor key={i} {...d} />
          ))}
        </div>

        {/* tarih / saat / mekan */}
        <div className="flex flex-col items-center gap-4">
          <div className="flex items-baseline gap-3">
            <span className="bday-jost text-[10px] sm:text-[11px] font-light uppercase tracking-[0.35em] text-[#F1EAD9]/60">
              Date:
            </span>
            <span className="bday-hand text-2xl sm:text-3xl text-[#F1EAD9]">05.09.2026, Saturday</span>
          </div>
          <div className="flex items-baseline gap-3">
            <span className="bday-jost text-[10px] sm:text-[11px] font-light uppercase tracking-[0.35em] text-[#F1EAD9]/60">
              Time:
            </span>
            <span className="bday-hand text-2xl sm:text-3xl text-[#F1EAD9]">21.00</span>
          </div>
          <div className="flex items-baseline gap-3 flex-wrap justify-center">
            <span className="bday-jost text-[10px] sm:text-[11px] font-light uppercase tracking-[0.35em] text-[#F1EAD9]/60">
              Location:
            </span>
            <span className="bday-hand text-2xl sm:text-3xl text-[#F1EAD9]">
              Writers Bar, Raffles Istanbul
            </span>
          </div>
        </div>

        {/* not — butona yakın dursun diye boşluk aşağı kaydırıldı,
            mekân satırı ile buton arasındaki toplam mesafe aynı kaldı */}
        <p className="bday-jost mt-16 text-[13px] sm:text-[14px] font-light tracking-[0.35em] text-[#C9AF87]">
          White outfits are{' '}
          {/* son harfin aralığı sıfırlanmazsa alt çizgi T'den sonra da devam
              eder; eksilen boşluk margin ile geri veriliyor */}
          <span className="underline decoration-1 underline-offset-[5px] mr-[0.35em]">
            NO<span className="tracking-normal">T</span>
          </span>{' '}
          allowed
        </p>

        {/* cta */}
        <a
          href={TYPEFORM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="bday-btn mt-8 inline-block"
        >
          I will be there!
        </a>

        </div>
      </main>
    </div>
  );
};

export default BirthdayInvite;
